
import styled from "styled-components";
import { fontFamilies } from "components/shared/tokens/typography";

// Re-export shared helpers so DDPoDetailsDesktop only needs one import
export {
  DesktopPage,
  TitleRow as TopRow,
  TitleBlock,
  Title,
  Actions,
  ActionButton,
  SummaryCard,
  SummaryItem,
  SummaryIcon,
  SummaryValue,
} from "components/core/Common/DesktopHelpers/DesktopHelpers";

const COLORS = {
  text: "#293142",
  muted: "#767c8f",
  label: "#9197a6",
  border: "#e6e9ef",
  brand: "#ef4f5f",
};



export const SummaryText = styled.div`
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 2px;
`;

export const SummaryLabel = styled.span`
  color: ${COLORS.label};
  font-size: 16px;
  line-height: 22px;
`;

export const ProductsCard = styled.div`
  overflow: hidden;
  border: 1px solid ${COLORS.border};
  border-radius: 16px;
  background: #ffffff;
`;

export const ProductsTitle = styled.h2`
  margin: 0;
  border-bottom: 1px solid ${COLORS.border};
  padding: 24px 24px 20px;
  background: #f8f9fc;
  color: ${COLORS.text};
  font-family: ${fontFamilies.semiBold};
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
`;

export const ProductImage = styled.img`
  width: 40px;
  height: 40px;
  border: 0.5px solid ${COLORS.border};
  border-radius: 4px;
  object-fit: cover;
`;

export const CellText = styled.span`
  color: ${COLORS.text};
  font-size: 14px;
  line-height: 20px;
`;

export const StateMessage = styled.div`
  padding: 64px 0;
  color: ${COLORS.muted};
  text-align: center;
`;

export const DetailsSummaryCard = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 8px;
  border-radius: 16px;
  padding: 24px;
  background: #ffffff;
`;
